import React from 'react'
import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "react-query"

import { Column } from 'components/Layout';
import InfoCell from 'components/Layout/InfoCell';
import TrackerDevicePage from "containers/Tracker/TrackerDevicePage"
import RadarpestDevicePage from './RadarpestDevicePage';

import { get } from "service/Client"
import { projects as projectsConstants } from "../../constants";


const DevicePage = () => {

    let { deviceid } = useParams()

    let { isLoading, data: device, error } = useQuery('device', () => get(`devices/${deviceid}`))
    let deviceTypeName = device?.projectTypeName

    if (isLoading) {
        return null
    }
    else if (error) {
        return <Navigate to="/404" />
    }

    switch (deviceTypeName) {
        case projectsConstants.names.TRACKER: return <TrackerDevicePage />
        case projectsConstants.names.RADARPEST: return <RadarpestDevicePage />
        default: return (
            <Column>
                <InfoCell name={"ID"} value={device.id} />
                <InfoCell name={"Seriale Sigfox"} value={device.deviceId} />
                <InfoCell name={"Label"} value={device.label || device.deviceId} />
                <InfoCell name={"Tipo"} value={device.projectTypeName} />
                <InfoCell name={"Progetto"} value={device.projectName} />
            </Column>
        )
    }

}

export default DevicePage
